import { HStack, Input, Text, VStack, Flex } from "@chakra-ui/react";
import { ru } from "date-fns/locale";
import DatePicker from "react-datepicker";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

const SelectDateDays = observer(() => {
  const { pageStore } = useStores();

  return (
    <VStack width={"100%"} padding={"10px"}>
      <Flex
        direction={{ base: "column", md: "row" }} // В колонку на мобильных, в ряд на ПК
        align="center"
        gap={2}
        width="100%"
        justify="center"
      >
        <DatePicker
          selected={pageStore.start_date_day}
          onChange={(e) => {
            pageStore.updateStartDateDay(e.toISOString().split("T")[0]);
            console.log(e.toISOString())
            pageStore.updateStartDateMonth("");
            pageStore.updateEndDateMonth("");
            pageStore.updateEndDateYear("");
            pageStore.updateStartDateYear("");
          }}
          dateFormat="dd.MM.yyyy"
          locale={ru}
          placeholderText="выберете день начала"
          customInput={
            <Input
              style={{
                width: "245px",
                border: "none",
                background: "#333",
                color: "#EEEEEE",
                borderRadius: "10px",
                fontWeight: 600,
              }}
            />
          }
        />
        <Text fontWeight={"600"} color={"myColor.white"}>
          —
        </Text>
        <DatePicker
          selected={pageStore.end_date_day}
          onChange={(e) => {
            pageStore.updateEndDateDay(e.toISOString().split("T")[0]);
            pageStore.updateStartDateMonth("");
            pageStore.updateEndDateMonth("");
            pageStore.updateEndDateYear("");
            pageStore.updateStartDateYear("");
          }}
          dateFormat="dd.MM.yyyy"
          locale={ru}
          placeholderText="выберете день конца"
          customInput={
            <Input
              style={{
                width: "245px",
                border: "none",
                background: "#333",
                color: "#EEEEEE",
                borderRadius: "10px",
                fontWeight: 600,
              }}
            />
          }
        />
      </Flex>
    </VStack>
  );
});

export default SelectDateDays;
